import { z } from 'zod';
import { UnknownError } from 'libs/end-to-end/src/types/errors/unknown-error';
import { ZodParseError } from 'libs/end-to-end/src/types/errors/zod-parse-error';
import { JsonParseFatalError } from 'libs/end-to-end/src/types/errors/json-parse-fatal-error';

export const JsonParseError = z.union([
  ZodParseError,
  JsonParseFatalError,
  UnknownError,
]);

export type JsonParseError = z.infer<typeof JsonParseError>;
